function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Blog"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M2.5 14.5L170.002 4l5 100-164.5 9.5-8-99z",
  className: "boxFill"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M172.292 1.795c.4.36.639.864.662 1.401l4.398 100.719a2 2 0 01-1.869 2.083L10.819 116.633a2 2 0 01-2.123-1.837L.716 14.233a2 2 0 011.866-2.154L170.828 1.288a1.999 1.999 0 011.464.507zM4.864 15.941l7.664 96.574 160.742-10.382-4.223-96.723L4.864 15.941z",
  className: "boxStroke",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  className: "semicircles"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M109.833 36.632c-9.833-5.346-21.36-5.607-28.96-4.167a2 2 0 11-.745-3.93c8.232-1.56 20.756-1.321 31.615 4.583 11.008 5.985 20.016 17.64 21.254 38.262a2 2 0 01-3.993.24c-1.163-19.377-9.488-29.723-19.171-34.988z",
  className: "outer",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M81.964 53.376a2.228 2.228 0 01-.584-.105 2 2 0 01.767-3.896l.127-.011.484-.05.517-.056a46.49 46.49 0 013.517-.242c2.854-.081 6.657.112 10.456 1.352 3.824 1.248 7.678 3.572 10.496 7.744 2.81 4.16 4.457 9.966 4.237 17.943a2 2 0 01-3.999-.11c.204-7.382-1.329-12.3-3.553-15.595-2.217-3.282-5.251-5.144-8.422-6.18-3.198-1.043-6.495-1.23-9.1-1.156a42.488 42.488 0 00-3.22.223l-.46.049c-.219.023-.42.045-.574.06a7.596 7.596 0 01-.418.03 3.168 3.168 0 01-.27 0zm.117-3.997c-.003 0-.002 0 0 0z",
  className: "inner",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  className: "BlogB"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M57.852 29.077a2 2 0 012.143 1.846l3.166 42.52a15.126 15.126 0 013.165-2.938c3.719-2.588 8.552-3.676 13.256-3.483 4.71.193 9.502 1.676 13.167 4.488C96.461 74.358 99 78.573 99 84c0 5.208-2.697 9.094-6.523 11.567-3.768 2.436-8.654 3.541-13.398 3.43-4.744-.11-9.582-1.443-13.227-4.16-3.4-2.535-5.717-6.258-5.865-11.075a2.003 2.003 0 01-.108-.517L56.007 31.22a2 2 0 011.846-2.143zM95 84c0-4.034-1.835-7.13-4.686-9.317-2.897-2.223-6.855-3.5-10.895-3.665-4.046-.165-7.963.79-10.807 2.77C65.839 75.72 64 78.668 64 82.853h-.013c-.13 3.89 1.559 6.767 4.256 8.777 2.824 2.105 6.798 3.272 10.93 3.368 4.13.097 8.18-.882 11.132-2.79C93.197 90.338 95 87.622 95 84z",
  className: "B",
  clipRule: "evenodd"
})));

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178,
    height: 117,
    fill: "none",
    viewBox: "0 0 178 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.3c2a3edd.svg";
export { ForwardRef as ReactComponent };